import { Controller } from '@hotwired/stimulus';

import urlParser from 'js-video-url-parser/lib/base';
import 'js-video-url-parser/lib/provider/youtube';

export default class extends Controller {
  connect() {
    const iframeTags = this.element.getElementsByTagName('iframe');
    Array.from(iframeTags).forEach((iframeTag) => {
      let videoInfo;
      const src = iframeTag.getAttribute('src');
      if (src) {
        videoInfo = urlParser.parse(src);
      }

      if (videoInfo) {
        const embedVideoUrl = urlParser.create({ videoInfo, format: 'embed' });
        let width = iframeTag.getAttribute('width');
        if (width) {
          width += 'px';
        } else {
          width = '100%';
        }
        iframeTag.outerHTML = `
            <div class="video-container" style="width: ${width};">
              <iframe src="${embedVideoUrl}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>`;
      }
    });
  }
}
